/**
 * Self-recovery from an expired Cloudflare Access session.
 *
 * When the Access cookie lapses, the edge answers asset and API
 * requests with a redirect to the login flow — module scripts get
 * text/html (blank screen), API calls surface as `access_redirect`.
 * A full *navigation* is the cure: it re-runs the Access handshake,
 * which re-issues the cookie silently while the identity-provider
 * session is alive (the common case), or shows the login page (the
 * correct outcome when it isn't). So: reload, at most once per
 * GUARD_MS — the guard breaks reload loops if Access keeps bouncing.
 *
 * The same key/guard is shared with the inline bootstrap script in
 * index.html, which handles the case where the app itself never
 * loaded and this module isn't available.
 */

const KEY = 'almanac-recover-at';
const GUARD_MS = 20_000;

export function recoverSessionOnce(): void {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < GUARD_MS) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Storage unavailable (rare) — still better to reload than stay
    // wedged; the navigation itself can't loop without a re-render.
  }
  window.location.reload();
}
